import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import {
    Col, Row
} from "reactstrap";


export default function ContactFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register } = formManager;//errors, control

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };


    register(bindPropResult);

    var frameClass = "d-inline-block";
    var frameStyle = {};
    var containerClass = "";

    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "";
    var formStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_contact");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
        }
        if (design.size || design.width) frameStyle.width = (design.size ? (design.size + "px") : design.width);
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) {
                //TEMP : Gestion décalage px/dp Android pour Home
                if (parentProps?.parentData?.groupSubName === "containerGroup" || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.groupSubName === "containerGroup") {
                    frameStyle.height = (parseFloat(design.height.replace("px", "")) * 2) + "px";
                }
                else {
                    frameStyle.height = design.height;
                }
            }
            else {
                frameClass += " h-100";
            }
        }
        if (design.maxWidth) frameStyle.maxWidth = design.maxWidth;

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));
    }
    //Design design sideAlphabet
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_contactInput", true);
    if (designInput) {
        if (designInput.fontColor) formStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
        if (designInput.fontSize) formStyle.fontSize = designInput.fontSize;
        if (designInput.fontStyle) {
            if (designInput.fontStyle.indexOf("bold") >= 0) formStyle.fontWeight = "bold";
            if (designInput.fontStyle.indexOf("italic") >= 0) formStyle.fontStyle = "italic";
        }
        Object.assign(formStyle, modelFctManager.setCustomBackground(designInput, data));
        Object.assign(formStyle, modelFctManager.manageMargin(designInput, formClass));
        Object.assign(formStyle, modelFctManager.managePadding(designInput, formClass));
    }

    //TODO
    //extrasDesign.get("contactLines") >> 
    /*if (designInput) {
        if (designInput.fontColor) textStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
        if (designInput.fontSize) textStyle.fontSize = designInput.fontSize;
        if (designInput.fontStyle) {
            if (designInput.fontStyle.indexOf("bold") >= 0) textStyle.fontWeight = "bold";
            if (designInput.fontStyle.indexOf("italic") >= 0) textStyle.fontStyle = "italic";
        }
        Object.assign(formStyle, modelFctManager.managePadding(design, formClass));
    }*/

    var rows = [];
    var fImage = [];
    var sImage = [];
    var fRow = [];
    var sRow = [];
    var tRow = [];

    data.childCount = data.children ? data.children.length : 0;
    var childs = data.children?.map((child) => {
        if (child?.groupSubName?.startsWith("item")) {

            var cpt = modelFctManager.componentTyped(child, {
                ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false),
                stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup"))
            });

            if (child.groupSubName?.endsWith("firstImage")) fImage.push(cpt);
            else if (child.groupSubName?.endsWith("secondImage")) sImage.push(cpt);
            else if (child.groupSubName?.endsWith("first")) fRow.push(cpt);
            else if (child.groupSubName?.endsWith("second")) sRow.push(cpt);
            else if (child.groupSubName?.endsWith("third")) tRow.push(cpt);

            rows.push(cpt);
            return "";
        }
        else {
            return modelFctManager.componentTyped(child, {
                ...parentProps, parentData: data, childs: data.children, parentDisabled: (parentDisabled || data.disabled ? true : false),
                stopPartition: (parentProps.stopPartition || data.groupSubName?.startsWith("containerGroup"))
            });
        }
    }) || "";


    var rowSample = <Row style={{ borderBottom: "1px solid grey" }}>
        <Col xs="2"><i className="fa fa-user-circle fa-4x"></i></Col>
        <Col xs="8">
            <Row>
                <Col xs="12" className="">Nom</Col>
                <Col xs="12" className="">Tel</Col>
                <Col xs="12" className="">Email</Col>
            </Row>
        </Col>
        <Col xs="2"><i className="fa fa-phone"></i><i className="fa fa-comment"></i></Col>
    </Row>;

    var baseForm = <div className={`${containerClass}`}>
        <div className="d-flex">
            <div className="" style={{ flex:"auto" }}>
                <Row className="justify-content-center">{childs}</Row>
                {rowSample}
                {rowSample}
            </div>
            <div className={`${formClass}`} style={formStyle}>
                <div>A</div>
                <div>L</div>
                <div>R</div>
                <div>V</div>
            </div>
        </div>
    </div>;

    //console.debug("render contact");

    return <Col data-name="ContactFrag" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}